import * as activity from 'app/mockdata/activity';
import * as auth from 'app/mockdata/auth';
import * as community from 'app/mockdata/community';
import * as earnings from 'app/mockdata/earnings';
import * as post from 'app/mockdata/post';
import * as user from 'app/mockdata/user';
import * as twitter from 'app/mockdata/twitter';

export { activity, auth, community, earnings, post, user, twitter };
